import { createComponent } from '../../core/create-component.js';
const H2 = createComponent({
  displayName: 'H2',
  root: 'h2',
  propConfig: {
    classNames: ['swan-heading']
  }
});
H2.defaultProps = {
  fontSize: 5,
  fontWeight: 'bold'
};
export { H2 };